import React from 'react';
import { pluralize } from '@sparknz/journeys-common';

import { StyledAvailabilityText } from './AvailabilityText.style';

type AvailabilityTextProps = {
  availability: number;
};

const AvailabilityText = ({ availability }: AvailabilityTextProps) => {
  return (
    <StyledAvailabilityText variant="bodySDemi">
      Available in {pluralize(availability, 'store')} near you
    </StyledAvailabilityText>
  );
};

export default AvailabilityText;
